import n, { useRef as e, useEffect as t } from "react";

function r(n, e, t) {
  return e in n ? Object.defineProperty(n, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = t, n;
}

var o = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  touchstart: "onTouchStart",
  touchend: "onTouchEnd"
};
export default function (u) {
  var c,
      i = u.children,
      a = u.onClickAway,
      v = u.mouseEvent,
      f = void 0 === v ? "click" : v,
      l = u.touchEvent,
      d = void 0 === l ? "touchend" : l,
      m = e(null),
      s = e(null),
      p = e(!1);
  t(function () {
    return setTimeout(function () {
      p.current = !0;
    }, 0), function () {
      p.current = !1;
    };
  }, []);

  var h = function h(n) {
    var e = n.event,
        t = n.type;
    s.current = e.target;
    var r = null == i ? void 0 : i.props[t];
    r && r(e);
  };

  return t(function () {
    var n = function n(_n) {
      p.current && (m.current && m.current.contains(_n.target) || s.current === _n.target || a(_n));
    };

    return document.addEventListener(f, n), document.addEventListener(d, n), function () {
      document.removeEventListener(f, n), document.removeEventListener(d, n);
    };
  }, [f, a, d]), n.Children.only(n.cloneElement(i, (r(c = {
    ref: function ref(n) {
      m.current = n;
      var e = i.ref;
      "function" == typeof e ? e(n) : e && (e.current = n);
    }
  }, o[f], function (n) {
    return h({
      type: o[f],
      event: n
    });
  }), r(c, o[d], function (n) {
    return h({
      type: o[d],
      event: n
    });
  }), c)));
}